<template>
  <div>
    <v-card class="mx-auto" width="1100px" style="margin-top: 0px; margin-bottom: 0px;" outlined>
      <validation-observer ref="validator" v-slot="{ handleSubmit }">

        <v-card-title class="font-weight-bold" style="font-size: 18px;">ĐẶT LỊCH HỌC THỬ</v-card-title>
        <v-card-title>
          <v-row>
            <v-col cols="12" md="4">
              <div class="d-flex flex-column align-start">
                <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                >Chọn chương trình
                  <span style="color: red">(*)</span>
                </label>
                <validation-provider
                    name="Chương trình"
                    :rules="'required'"
                    v-slot="{ errors }"
                    slim
                >
                  <v-autocomplete
                      placeholder="Chọn chương trình"
                      class="trial-form w-100"
                      :error-messages="errors"
                      v-model="trialForm.curriculum"
                      solo
                      dense
                      :items="curriculumsTrial"
                      item-value="id"
                      item-text="name"
                      return-object
                      @change="getSectionType"
                  >
                  </v-autocomplete>
                </validation-provider>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex flex-column align-start">
                <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                >Chọn loại hình học thử
                  <span style="color: red">(*)</span>
                </label>
                <validation-provider
                    name="Loại hình học thử"
                    :rules="'required'"
                    v-slot="{ errors }"
                    slim
                >
                  <v-autocomplete
                      placeholder="Chọn loại hình"
                      :error-messages="errors"
                      class="trial-form w-100"
                      v-model="trialForm.section"
                      :items="typeSections"
                      item-value="id"
                      item-text="title"
                      :disabled="!trialForm.curriculum"
                      solo
                      dense
                      return-object
                      @change="checkDiasble"
                  >
                  </v-autocomplete>
                </validation-provider>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex flex-column align-start">
                <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                >Chọn trường
                  <span style="color: red">(*)</span>
                </label>
                <validation-provider
                    name="Trường"
                    :rules="'required'"
                    v-slot="{ errors }"
                    slim
                >
                  <v-autocomplete
                      placeholder="Chọn trường"
                      :error-messages="errors"
                      class="trial-form w-100"
                      v-model="trialForm.school"
                      :items="schools"
                      item-text="school_name"
                      item-value="id"
                      solo
                      dense
                      return-object
                  >
                  </v-autocomplete>
                </validation-provider>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div v-if="selectDay" class="d-flex flex-column align-start">
                <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                >Chọn ngày
                  <span style="color: red">(*)</span>
                </label>
                <validation-provider
                    name="Ngày"
                    :rules="'required'"
                    v-slot="{ errors }"
                    slim
                >
                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          :error-messages="errors"
                          @click:clear="onClearClicked"
                          v-model="dates"
                          placeholder="Chọn ngày"
                          class="trial-form w-100"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          solo
                          dense
                          type="text"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        no-title
                        v-model="dates"
                        :min="nowDate"
                        event-color="blue lighten-1"
                        class="pick-odd date-pick-slot"
                    >
                    </v-date-picker>
                  </v-menu>
                </validation-provider>
              </div>
              <div v-else class="d-flex flex-column align-start">
                  <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                  >Chọn khoảng ngày
                    <span style="color: red">(*)</span>
                  </label>
                  <validation-provider
                      name="Khoảng ngày"
                      :rules="'required'"
                      v-slot="{ errors }"
                      slim
                  >
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :error-messages="errors"
                            @click:clear="onClearClicked"
                            v-model="rangeDay"
                            placeholder="Chọn khoảng ngày"
                            class="trial-form w-100"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            dense
                            type="text"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          no-title
                          v-model="dateRange"
                          :min="nowDate"
                          range
                          event-color="blue lighten-1"
                          class="pick-odd date-pick-slot"
                      >
                      </v-date-picker>
                    </v-menu>
                  </validation-provider>
                </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex flex-column align-start">
                <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                >Chọn ca
                </label>
                <v-autocomplete
                    class="trial-form w-100"
                    placeholder="Chọn ca"
                    v-model="trialForm.caseId"
                    :items="CA_HOC"
                    item-text="name"
                    item-value="id"
                    solo
                    dense
                >
                </v-autocomplete>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div class="d-flex flex-column align-start">
                <label for="" style="color: #000000; font-size: 16px; font-weight: normal"
                >Chọn con
                  <span style="color: red">(*)</span>
                </label>
                <validation-provider
                    name="Chọn con"
                    :rules="'required'"
                    v-slot="{ errors }"
                    slim
                >
                  <v-autocomplete
                      :error-messages="errors"
                      class="trial-form w-100"
                      v-model="trialForm.childId"
                      :items="contactQuickviewDetail.childCustomer"
                      item-text="fullName"
                      placeholder="Chọn con"
                      solo
                      dense
                      return-object
                  >
                  </v-autocomplete>
                </validation-provider>
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-actions>
          <div class="d-flex justify-center flex-column align-center">
            <v-btn :disabled="!disableSearch" color="#0088FF" width="235" height="35px" style="text-transform: unset; font-size: 17px;" @click.prevent="handleSubmit(setupSchedule('create'))">Đặt lịch cho vận hành</v-btn>
            <div class="d-flex align-center my-4">
              <div class="line"></div>
              <span class="mx-1" style="color: #AEAEAE">Hoặc</span>
              <div class="line"></div>
            </div>
            <v-btn :disabled="disableSearch" color="#FD1F6D" width="235" height="35px" style="font-size: 17px; text-transform: unset; " @click.prevent="handleSubmit(suggestSchedule)">Tìm kiếm lịch học thử</v-btn>
          </div>
        </v-card-actions>
      </validation-observer>


      <v-data-table
          v-if="showTable"
          :headers="headers"
          :items="schedules"
          class="elevation-1"
          :disable-sort="true"
          @page-count="pageCount = $event"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
      >
        <template v-slot:item.tick="{ item }">
          <v-checkbox :disabled="disableCheckbox(item)" v-model="item.check"></v-checkbox>
        </template>
      </v-data-table>
      <div v-if="schedules.length">
        <div class="text-center d-flex justify-space-between pb-2 pt-2 align-center">
          <v-pagination
              style="width: fit-content"
              v-model="page"
              :length="pageCount"
              circle
          ></v-pagination>
          <div>
            <div class="d-flex align-center">
              <span>Số buổi  đã chọn <b>{{checked}}/4</b> buổi</span>
              <v-btn :disabled="!checked" @click="warning = true" class="ml-6" color="#0088FF" style="height: 35px; width: 96px;"> Đặt lịch </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="warning" max-width="370">
      <v-card
          class="mx-auto"
          width="370"
      >
        <div class="d-flex my-3">
          <v-icon class="mx-5" style="font-size: 70px; color: #0a4eaf; height: 65px">mdi-information</v-icon>
          <div>
            <h3 class="mb-3">Bạn đã đặt lịch học thử các buổi</h3>
            <template v-for="(schedule, index) in getClassLesson">
              <h4 :key="index">{{schedule.class_code}}</h4>
              <p class="mb-0" v-for="(time, key) in schedule.timeLesson" :key="key + `_${index}`"><v-icon style="font-size: 24px;">mdi-circle-small</v-icon>{{time}}</p>
            </template>
            <div class="mt-3">
              <v-btn
                  color="#0088FF"
                  style="text-transform: uppercase"
                  height="34"
                  @click="setupSchedule('setup')"
              >
                Xác Nhận
              </v-btn>

              <v-btn
                  height="34"
                  color="#ccc"
                  @click="warning = false"
              >
                HỦY
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>

    </v-dialog>
  </div>

</template>

<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import moment from "moment";
import TokenService from "../../../helpers/token";
import { moduleSchoolLevel } from '@/helpers/constants';

const SchoolRepository = RepositoryFactory.get('school');
const TutorTestRepository = RepositoryFactory.get("tutorTest");
const user = TokenService.getUser();
const CA_HOC = [
  {id: 1, name: "Ca Sáng"},
  {id: 2, name: "Ca Chiều"},
  {id: 3, name: "Ca Tối"},
]
const dates = {
  Monday: "Thứ 2",
  Tuesday: "Thứ 3",
  Wednesday: "Thứ 4",
  Thursday: "Thứ 5",
  Friday: "Thứ 6",
  Saturday: "Thứ 7",
  Sunday: "Chủ nhật",
};

export default {
  name: "ModalPickTrial",
  props: {
    curriculums: {
      type: Array,
      default: () => [],
    },
    contactQuickviewDetail: {
      type: Object,
      default: () => {}
    },
    closePickTrial: {
      type: Function,
    }
  },
  data() {
    return {
      moduleSchoolLevel,
      trialForm: {
        curriculum: null,
        childId: null,
        section: null,
        caseId: null,
        school: null
      },
      currentPicker: null,
      dates: null,
      nowDate: new Date().toISOString().slice(0,10),
      date: [],
      schools: [],
      CA_HOC,
      typeSections: [],
      curriculumsTrial: [],
      schedules: [],
      // menu2: false,
      headers: [
        { text: 'Tick', value: 'tick', class: 'coulums-table', align: 'start' },
        {
          text: 'Mã lớp',
          align: 'start',
          sortable: false,
          value: 'class_code',
          class: 'coulums-table'
        },
        { text: 'Lịch học', value: 'schedule', class: 'coulums-table', align: 'start' },
        { text: 'Giáo viên', value: 'teacher_name', class: 'coulums-table', align: 'start' },
        { text: 'Chương trình', value: 'curriculum_name', class: 'coulums-table', align: 'start' },
        { text: 'Trình độ', value: 'class_level', class: 'coulums-table text-nowrap-table ', align: 'start' },
        { text: 'Sĩ số', value: 'slot', class: 'coulums-table text-nowrap-table ', align: 'start' },
        { text: 'Dung lượng', value: 'capacity', class: 'coulums-table text-nowrap-table ', align: 'center' },
        { text: 'Bài học', value: 'lesson_title', class: 'coulums-table', align: 'start' },
      ],
      footerProps: {
        'items-per-page-options': [10, 20, 30], // Customize the items per page options if needed
        'items-per-page-text': 'Số phần tử / trang:', // Customize the items per page text
        'page-text': 'Lịch học {0}-{1}/{2}', // Customize the page text
      },
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      totalItem: null,
      start: 0,
      end: 10,
      showTable: false,
      disableSearch: false,
      selectDay: true,
      dateRange: [],
      warning: false,
    }
  },
  async created() {
    await this.curriculumTrial();
    this.getTypeSection();
    this.getListSchool();
  },
  methods: {
    showDate(index) {
      this.currentPicker = index;
    },
    async getListSchool() {
      let attrs = '&attrs[]=id&attrs[]=school_name&filters[$eq__status]=1'
      if([this.moduleSchoolLevel.STATION,this.moduleSchoolLevel.SCHOOL].includes(this.moduleschoolLevelId)) {
          attrs += this.moduleschoolLevelId === this.moduleSchoolLevel.STATION ? '&filters[$eq__type]=station' : '&filters[$eq__type]=school'
      }
      const response = await SchoolRepository.listSchoolApi(attrs);
      this.schools = _.get(response, 'data');
    },
    async suggestSchedule() {
      this.showTable = true;
      this.page = 1;
      let params = {
        obj: 'class_lesson_filter',
        attrs: ["id", "curriculum_name", "lesson_title", "lesson_id", "teacher_name",
          "teacher_id", "class_code", "class_id", "class_level", "lesson_start_time",
          "curriculum_id", "capacity", "total_student_trial", "class_start_date",
          "lesson_end_time", "total_students", "school_id", "class_type"],
        "filters[$eq__curriculum_id]": this.trialForm.curriculum?.id,
        "filters[$between__lesson_start_time]": [`${this.dates} 00:00:00`, `${this.dates} 23:59:59`],
        "filters[$eq__school_id]": this.trialForm.school.id,
        'sorts[class_start_date]': 'desc',
        'sorts[class_code]': 'asc',
        'sorts[lesson_start_time]': 'asc',
        'sorts[total_students]': 'asc',
      }
      if (this.trialForm.section.learn_type != 1) {
        let dateTo = null;
        if (this.dateRange?.length > 1) {
          dateTo = this.dateRange[1]
        }
        if (this.dateRange?.length == 1) {
          dateTo = this.dateRange[0]
        }
        params = {
          ...params,
          "filters[$between__lesson_start_time]": [`${this.dateRange[0]} 00:00:00`, `${dateTo} 23:59:59`],
        }
      }
      if (this.trialForm.caseId) {
        params["filters[$eq__shift_id]"] = this.trialForm.caseId;
      }
      const loader = this.$loading.show();
      const response = await TutorTestRepository.fgApi(params);
      this.schedules = _.get(response, 'data', []) || [];
      this.totalItem = _.get(response, 'totalItem')
      this.schedules = this.schedules.map((item) => {
       const hourStart = moment(item.lesson_start_time).format('HH:mm')
        if (moment(item.lesson_end_time).isAfter(moment())) {
          const days = moment(item.lesson_end_time)?.format("HH:mm DD/MM/YYYY");
          const dayOfWeek = moment(item.lesson_end_time)?.format("dddd");
          const endTimeHour = moment(item.lesson_end_time)?.format("HH:mm");
          return {
            ...item,
            check: false,
            schedule: [hourStart, days]?.join(" - ") || '--',
            timeLesson: `${hourStart} - ${endTimeHour}, ${dates[dayOfWeek]} ${moment(item.lesson_end_time)?.format("DD/MM/YYYY")}`,
            slot: [(item.total_students + item?.total_student_trial) ?? 0, item.class_type ?? '0']?.join("/"),
            action: 'mdi-arrow-right-circle',
            class_level: `Level ${item.class_level}`
          }
        }
        return null;
      }).filter(item => item !== null);
      loader.hide();
    },
    async getTypeSection() {
      const params = {
        obj: 'tutor-curriculum-sections',
        attrs: ["code", "id", "title", "curriculum_id", "learn_type", "study_type"],
        "filters[$eq__status]": 1,
        "filters[$eq__study_type]": 1,
      }
      const response = await TutorTestRepository.fgApi(params);
      this.typeSections = _.get(response, 'data');
      this.typeSectionsClone = _.cloneDeep(this.typeSections)

    },
    async setupSchedule(item) {
      const valid = await this.$refs.validator.validate();
      if (this.trialForm.section.learn_type == 1 && !this.dates) return;
      if (!valid) return;
      let payload = {
        data: {
          curriculum_id: this.trialForm.curriculum?.id,
          curriculum_name: this.trialForm.curriculum?.name,
          curriculum_section_id: this.trialForm.section?.id,
          curriculum_section_title: this.trialForm.section?.title,
          school_id: this.trialForm.school?.id,
          school_name: this.trialForm.school?.school_name,
          contact_id: this.trialForm.childId?.contactId,
          customer_id: this.trialForm.childId?.id,
          lesson_start_time: this.dates,
          lesson_end_time: this.dates,
          student_full_name: this.trialForm.childId?.fullName,
          student_mobile: this.trialForm.childId?.mobile,
          create_user: user.id,
          create_user_name: `${user.lastName} ${user.firstName}`,
          update_user: user.id,
          customer_code: this.contactQuickviewDetail?.code,
        },
        obj: 'lesson_trial',
      };
      if (item && item != 'create' ) {
        const itemActives = this.schedules.filter(s => s.check);
        const data = [];
        for (const itemActive of itemActives) {
          data.push({
            curriculum_id: itemActive.curriculum_id,
            curriculum_name: itemActive.curriculum_name,
            curriculum_section_id: this.trialForm.section?.id,
            curriculum_section_title: this.trialForm.section?.title,
            school_id: this.trialForm.school?.id,
            school_name: this.trialForm.school?.school_name,
            contact_id: this.trialForm.childId?.contactId,
            customer_id: this.trialForm.childId?.id,
            lesson_start_time: itemActive.lesson_start_time,
            lesson_end_time: itemActive.lesson_end_time,
            student_full_name: this.trialForm.childId?.fullName,
            student_mobile: this.trialForm.childId?.mobile,
            create_user: user.id,
            update_user: user.id,
            lesson_title: itemActive.lesson_title,
            create_user_name: `${user.lastName} ${user.firstName}`,
            lesson_id: itemActive?.lesson_id,
            lesson_class_id: itemActive?.class_id,
            lesson_class_code: itemActive?.class_code,
            teacher_id: itemActive?.teacher_id,
            teacher_name: itemActive?.teacher_name,
            customer_code: this.contactQuickviewDetail?.code,
          })
        }
        const loader = this.$loading.show();
        const response = await TutorTestRepository.createTrial(data);
        loader.hide();
        if (response.success) {
          this.$swal({
            title: 'Đặt lịch học thử thành công!',
            icon: 'success',
          })
          this.closePickTrial();
          this.$emit('setTrialSuccess')
        } else {
          this.$swal({
            title: _.get(response, 'message', ''),
            icon: 'warning',
          })
        }
        return;
      }
      const response = await TutorTestRepository.fgApiSet(payload)
      if (response.success) {
        this.$swal({
          title: 'Đặt lịch thành công!',
          icon: 'success',
        })
        this.closePickTrial();
        this.$emit('setTrialSuccess')
      } else {
        this.$swal({
          title: 'Lỗi hệ thống, vui lòng thử lại!',
          icon: 'warning',
        })
      }
    },
    onClearClicked() {
      this.dates = null;
    },
    curriculumTrial() {
      for (const curriculum of this.curriculums) {
        for (const item of curriculum.test_type) {
          if (item.type_placement_test == "trial") {
            this.curriculumsTrial.push(curriculum)
          }
        }
      }
      this.curriculumsTrial = _.uniqBy(this.curriculumsTrial, 'id')
    },
    getSectionType() {
      this.disableSearch = false;
      let sections = []
      for (const section of this.typeSectionsClone) {
        if (this.trialForm.curriculum?.id == section.curriculum_id) {
          sections.push(section)
        }
      }
      const hasLearnTypeP = sections.some(item => item.learn_type === 1);
      const hasLearnTypeC = sections.some(item => item.learn_type === 2);

      this.typeSections = sections;
      if (hasLearnTypeP && hasLearnTypeC) {
        sections = [{id: -1, title: "Trial Full", learn_type: 2}, ...sections];
      }
      this.typeSections = sections;
    },
    checkDiasble() {
      this.dateRange = [];
      this.schedules = [];
      this.dates = null;
      if (this.trialForm.section?.learn_type == 1) {
        this.disableSearch = true;
        this.selectDay = true;
      } else {
        this.disableSearch = false;
        this.selectDay = false;
      }
    },
    disableCheckbox(item) {
      if (this.checked == 4 && !item.check) {
        return true
      }
      if (this.checked < 4 && !item.check) {
        return false
      }
    }
  },
  computed: {
    rangeDay() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dateRange?.sort()?.join(' ~ ');
    },
    checked() {
      return this.schedules.filter(s => s.check)?.length;
    },
    getClassLesson() {
      const schedules = this.schedules.filter(s => s.check)
      const transformedArray = _.mapValues(
          _.groupBy(schedules, 'class_code'),
          group => ({ class_code: group[0].class_code, timeLesson: _.map(group, 'timeLesson') })
      );
      return Object.values(transformedArray) || [];
    },
    moduleschoolLevelId() {
      return this.$store.state.module.schoolLevelId
    }
  },
}
</script>

<style scoped>
.trial-form {
  padding-top: 0 !important;
}
.line{
  height: 1px;
  background-color: #AEAEAE;
  width: 200px;
}
/*/deep/.text-nowrap-table {*/
/*  white-space: nowrap!important;*/
/*}*/
/deep/.v-data-table-header {
  background-color: #1C3545 !important;
}
/deep/.coulums-table {
  color: #fff!important;
  position: sticky!important;
  top: 0;
  background: #1C3545!important;
  z-index: 9!important;
}
/deep/.v-data-table__empty-wrapper {
  color: red!important;
}
/deep/.v-data-table__wrapper {
  overflow-y: auto!important;
  max-height: 350px!important;
}
</style>
